import logo from "../../assets/logo.svg";
import { Link } from "react-router-dom";

const Navbar = () => {
  const handleMenu = () => {
    document.querySelector(".main-nav .menu").classList.toggle("active");
  };
  return (
    <nav className="navbar main-nav fixed-top" id="main-nav">
      <Link to="/" className="logo">
        <img src={logo} alt="" />
      </Link>
      <ul className="menu navbar">
        <li>
          <Link to="/">الرئيسية</Link>
        </li>
        <li>
          <Link to="/Blog">المقالات</Link>
        </li>
        <li>
          <Link to="/Charts">الترتيبات</Link>
        </li>
        <li>
          <Link to="/About">حولنا</Link>
        </li>
        <li>
          <Link to="/FAQ">FAQ</Link>
        </li>
      </ul>
      <div className="icons">
        <div className="menu-icon" onClick={handleMenu}>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
